import React, { Component } from "react";

export default class RemarkInput extends Component {
  render() {
    return (
      <div className="row">
        <div className="form-group col-md-6">
          <div>
            <label htmlFor="remark" className="col-sm-12">
              Remark
            </label>
          </div>
          <div className="col-sm-10">
            <textarea
              className="form-control"
              id="remark"
              cols="40"
              rows="2"
              value={this.props.value}
              onChange={this.props.onChange}
            />
          </div>
        </div>
      </div>
    );
  }
}
